import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@eatclubapp/ec-component-library';

const PrimaryChip = ({ children, className, ...props }) => {
  return (
    <Box className={className} {...props}>
      {children}
    </Box>
  );
};

PrimaryChip.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default PrimaryChip;
